module.exports = __webpack_public_path__ + "static/content-development.8bb51d6c.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/terrymasher/Development/glenbeigh-ltd/src/static/img/content-development.jpg
// module id = 283
// module chunks = 0 1